import React from 'react';
import Head from '../partials/Head';
import TheLoop from '../partials/TheLoop';
import Foot from '../partials/Foot';
import {Provider} from '../context/Context'
import ProfileHolder from '../partials/ProfileHolder';

// import CommentList from '../partials/CommentList';
// import CommentForm from '../partials/CommentForm';

const Single = (props) => {



  // let comments = '';
  // let commentsForm = '';

  // if(props.match.path === '/post/:slug'){
  //   comments = <CommentList></CommentList>;
  //   commentsForm = <CommentForm></CommentForm>;
  // }
  // console.log(Provider);

  return (
    <Provider router={props} >
      <div className="Post" style={{minHeight:"90vh"}}>
        <Head></Head>
        <div className="content-area">
        <TheLoop></TheLoop>
        <ProfileHolder />
        </div>
        {/*{comments}
        {commentsForm}*/}
        <Foot></Foot>
      </div>
    </Provider>
  )

}
export default Single